import styled from "styled-components";

const InputFormContainer = styled.div`
  width: 400px;
  padding: 30px;
  background: white;
  margin: 0 auto;
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    width: ${(props) => props.theme.contentWidth.mobile};
  }
  h2 {
    text-align: center;
  }
  .text-align-center {
    text-align: center;
  }
`;

export default InputFormContainer;
